/* <product-card-variants> — kart ve hızlı bakışta 30/60 hap seçici: fiyat, görsel ve buton durumunu günceller */
if (!customElements.get('product-card-variants')) {
  class ProductCardVariants extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[data-variant-scope]') || this.parentElement;
      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) this.update(e.target);
        else if (e.target.matches('select')) this.update(e.target.selectedOptions[0]);
      });
    }

    /* input: seçili radio ya da <option> (data-available, data-price, data-image, data-srcset) */
    update(input) {
      if (!input) return;
      const scope = this.scope;
      const available = input.dataset.available === 'true';

      const tpl = this.querySelector(`template[data-variant-price="${input.value}"]`);
      const priceTarget = scope.querySelector('[data-variant-price-target]');
      if (tpl && priceTarget) priceTarget.replaceChildren(tpl.content.cloneNode(true));

      const img = scope.querySelector('.card-product__img--primary, .quick-view__image');
      if (img && input.dataset.image) {
        img.src = input.dataset.image;
        if (input.dataset.srcset) img.srcset = input.dataset.srcset;
      }

      scope.querySelectorAll('[data-variant-submit]').forEach((btn) => {
        btn.disabled = !available;
        const label = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        const text = btn.querySelector('[data-variant-submit-label]');
        if (text) text.textContent = label;
        else if (label) btn.setAttribute('aria-label', label);
      });

      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variantId: Number(input.value), available, price: Number(input.dataset.price || 0) },
        })
      );
    }
  }
  customElements.define('product-card-variants', ProductCardVariants);

  /* Sepete eklenince kart butonunda kısa onay */
  if (window.CPL && CPL.subscribe) {
    CPL.subscribe(CPL.events.cartUpdate, ({ items }) => {
      (items || []).forEach((item) => {
        document.querySelectorAll('.card-product__form').forEach((form) => {
          const field = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
          if (!field || Number(field.value) !== item.variant_id) return;
          const btn = form.querySelector('.card-product__add');
          if (!btn) return;
          btn.classList.add('is-added');
          clearTimeout(btn._addedTimer);
          btn._addedTimer = setTimeout(() => btn.classList.remove('is-added'), 1400);
        });
      });
    });
  }
}
